module.exports = __webpack_public_path__ + "img/req_yi_bg.be201436.png";